import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const BACSContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${props => props.theme.spacing.sp32};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp32};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const InfoTitle = styled.div`
  margin: 0;
  font-family: ${props => props.theme.texts.titleS.fontFamily};
  font-size: ${props => props.theme.texts.titleS.fontSize};
  font-weight: 600;
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-bottom: ${props => props.theme.spacing.sp4};
`

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};

  & > div {
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.sp4};
  }
`

export const PendingSignContainer = styled.div`
  width: fit-content;
`
